import { User, AuthTokens } from '../types/auth';
import { clearLegacyAuthStorage } from './authSession';

export const storage = {
  setUser: (user: User) => {
    try {
      localStorage.setItem('user', JSON.stringify(user));
    } catch (error) {
      console.error('Failed to store user data:', error);
    }
  },
  
  getUser: (): User | null => {
    try {
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Failed to retrieve user data:', error);
      // Clear corrupted data
      localStorage.removeItem('user');
      return null;
    }
  },
  
  setTokens: (tokens: AuthTokens) => {
    void tokens;
    clearLegacyAuthStorage();
  },

  getTokens: (): AuthTokens | null => {
    clearLegacyAuthStorage();
    return null;
  },

  clearTokens: () => {
    clearLegacyAuthStorage();
  },
  
  clearUser: () => {
    try {
      localStorage.removeItem('user');
    } catch (error) {
      console.error('Failed to clear user data:', error);
    }
  },
  
  clearAuth: () => {
    try {
      // Clear all possible auth-related items
      localStorage.removeItem('user');
      clearLegacyAuthStorage();
    } catch (error) {
      console.error('Failed to clear auth data:', error);
    }
  }
};
